module.exports = __webpack_public_path__ + "img/電気回路_5_3_3.085ae6e6.png";